import { Flat } from '@dreryk/address-common-api';

import { BindingCreator } from '@dreryk/react-common';
import { FlatInput } from '@dreryk/react-components';

const FLAT_FIELD_NAME = 'flat';
const FLAT_MAX_LENGTH = 10;

export type FlatFormBeanPart = {
   [FLAT_FIELD_NAME]: Flat | null;
};

type FlatFieldProps = {
   readonly register: BindingCreator<FlatFormBeanPart, typeof FLAT_FIELD_NAME>;
};

export const FlatField = (props: FlatFieldProps): JSX.Element => {
   return (
      <FlatInput
         controller={props.register(FLAT_FIELD_NAME, {
            /*
             * TODO: DREGAB-19275 - Poprawa walidacji tak by populowała walidacje z wnętrza komponentu
             * react-components i nie trzeba było ich powtarzać ponownie podczas rejestracji pola
             */
            maxLength: FLAT_MAX_LENGTH,
         })}
         testId={FLAT_FIELD_NAME}
      />
   );
};
